import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getTodaySchedule } from '../../services/api';
import './TodayShiftsWidget.css';

const UsersIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"
       strokeLinejoin="round" aria-hidden="true">
    <circle cx="9" cy="8" r="3.5" /><path d="M2.5 20c.8-3.6 3.4-5.5 6.5-5.5s5.7 1.9 6.5 5.5" />
    <circle cx="17" cy="9" r="2.5" /><path d="M16 14.6c2.6.1 4.6 1.8 5.3 4.9" />
  </svg>
);

// Кто сегодня на смене — из расписания раздела «Сотрудники». Виден только
// ролям с доступом к «Сотрудникам» (ручка отвечает 403 — виджет молча
// скрывается), и только если на сегодня в расписании вообще что-то есть:
// пустой блок на дашборде у заведения, которое не ведёт расписание, — шум.
const TodayShiftsWidget = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    getTodaySchedule().then(setData).catch(() => setData(null));
  }, []);

  if (!data || (!data.shifts.length && !data.absent.length)) return null;

  return (
    <div className="ts-widget">
      <div className="ts-header">
        <div className="ts-icon"><UsersIcon /></div>
        <div className="ts-info">
          <div className="ts-title">Сегодня на смене · {data.shifts.length}</div>
          {data.absent.length > 0 && (
            <div className="ts-subtitle">
              Отсутствуют: {data.absent.map(a => `${a.full_name} (${a.kind_label.toLowerCase()})`).join(', ')}
            </div>
          )}
        </div>
        <Link to="/employees" className="ui-btn-ghost ts-link">Расписание</Link>
      </div>

      {data.shifts.length > 0 && (
        <ul className="ts-list">
          {data.shifts.map(s => (
            <li key={s.id} className="ts-item">
              <span className="ts-name">{s.full_name}</span>
              {s.position && <span className="ts-position">{s.position}</span>}
              <span className="ts-time">{s.start_time}–{s.end_time}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default TodayShiftsWidget;
